export default __webpack_public_path__ + "static/media/iphone-x-mockup.2c150f11.png";